<div class="dealer" *ngIf="_dealer">
	<span>Dealer: {{ _dealer.name }} ( {{ _dealer.dealerName }} )</span>
	<div class="product" *ngIf="_dealer.service && !_dontShow">
		<img
			[src]="_dealer.service.image"
			[alt]="_dealer.service.name.toLowerCase()"
		/>
		<span>{{ _dealer.service.name }}</span>
	</div>
	<button mat-raised-button (click)="_logoutDealer()">Logout</button>
</div>
<div class="dealer" *ngIf="_kiosk">
	<span>Kiosk: {{ _kiosk.name }} ( {{ _kiosk.dealerName }} )</span>
	<div class="product" *ngIf="_kiosk.service && !_dontShow">
		<img
			[src]="_kiosk.service.image"
			[alt]="_kiosk.service.name.toLowerCase()"
		/>
		<span>{{ _kiosk.service.name }}</span>
	</div>
	<button mat-raised-button (click)="_logoutKiosk()">Logout</button>
</div>
